module.exports = __webpack_public_path__ + "static/img/18.ecd9448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/18.png
// module id = +V9M
// module chunks = 1